import React from "react";
import { Doughnut } from "react-chartjs-2";
import SectionCard from "../shared/SectionCard";
import "../shared/chartSetup";

const DOUGHNUT_OPTS = {
  responsive: true,
  maintainAspectRatio: false,
  cutout: "72%",
  plugins: {
    legend: { display: false },
    tooltip: { enabled: true },
  },
};

const EMPTY_CHART = {
  labels: [],
  datasets: [{ data: [], backgroundColor: [], borderWidth: 0 }],
};

/**
 * Channel breakdown card: mini doughnut chart on the left + labelled legend list on the right.
 *
 * @param {string}   title
 * @param {{
 *   labels:      string[],
 *   values:      number[],
 *   chartValues: number[],
 *   pcts:        string[],
 *   colors:      string[],
 * }} data
 * @param {number}  [donutSize=110]  Width and height of the doughnut container in px
 */
const ChannelBreakdownCard = ({ title, data, donutSize = 110 }) => {
  const labels = data?.labels ?? [];
  const values = data?.values ?? [];
  const pcts = data?.pcts ?? [];
  const colors = data?.colors ?? [];
  const chartValues = data?.chartValues ?? values;

  const hasData = labels.length > 0;

  const chartData = hasData
    ? {
        labels,
        datasets: [
          {
            data: chartValues,
            backgroundColor: colors,
            borderWidth: 0,
            hoverOffset: 4,
          },
        ],
      }
    : EMPTY_CHART;

  return (
    <SectionCard title={title}>
      {hasData ? (
        <div className="d-flex align-items-center gap-3">
          {/* Doughnut */}
          <div style={{ height: donutSize, width: donutSize, flexShrink: 0 }}>
            <Doughnut data={chartData} options={DOUGHNUT_OPTS} />
          </div>

          {/* Legend list */}
          <div className="flex-fill">
            {labels.map((lbl, i) => (
              <div
                key={lbl ?? i}
                className="d-flex align-items-center gap-2 mb-1"
              >
                <div
                  className="rounded-circle flex-shrink-0"
                  style={{
                    width: 8,
                    height: 8,
                    background: colors[i] ?? "#ccc",
                  }}
                />
                <div
                  className="flex-fill"
                  style={{ fontSize: "0.72rem", color: "#344054" }}
                >
                  {lbl}
                </div>
                <div
                  style={{
                    fontSize: "0.68rem",
                    color: "#667085",
                    whiteSpace: "nowrap",
                  }}
                >
                  {pcts[i] ?? "—"}
                </div>
              </div>
            ))}
          </div>
        </div>
      ) : (
        <div
          className="d-flex align-items-center justify-content-center"
          style={{ height: donutSize, color: "#98A2B3", fontSize: "0.78rem" }}
        >
          No data available
        </div>
      )}
    </SectionCard>
  );
};

export default ChannelBreakdownCard;
